import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-12 px-4 border-t border-slate-800 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2 group">
            <div className="relative">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                <span className="text-white font-bold text-lg">B</span>
              </div>
              <Sparkles className="absolute -top-1 -right-1 w-4 h-4 text-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
            <span className="text-xl font-bold text-white">buildex.dev</span>
          </div>
          <div className="flex items-center gap-6 text-slate-400">
            <Link to="/policy/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/policy/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/policy/refunds" className="hover:text-white transition-colors">Refunds</Link>
            <Link to="/policy/shipping" className="hover:text-white transition-colors">Shipping</Link>
            <Link to="/policy/contact" className="hover:text-white transition-colors">Contact</Link>
          </div>
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} buildex.dev. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
